import {Fragment, React, useAsObservableSource, useEffect, useLocalStore, _} from '@api'
import {CatalogDataItem_Mapped, CatalogItemsListStore, ICatalogItemDetailsPathElement, LoadingIndicator, useCatalogItemsListStore, useVipLocalStore, VipLocalStore} from '@modules'
import {CatalogDataItem} from './'
import * as css from './CatalogItemsList.css'
import {onSiteError, StoresInstance} from '@stores'
import {EmptyDrawer} from 'centric-ui-components'
import {action, autorun, observable, reaction, runInAction, toJS, trace} from 'mobx'
import {observer} from 'mobx-react-lite'

export class CatalogItemsDataVirtualRowStore extends VipLocalStore {
  constructor(stores: StoresInstance,public props: { index: number }, public store: CatalogItemsListStore) {
    super(stores)
    store.virtualRows.set(props.index, this)
  }

  @observable.ref error
  @observable loading = true
  @observable.ref data

  registerEffects = () => {
    const {catalog} = this
    const toDispose = [
      autorun(async () => {
        const {store, store: {sectionValues, library, catalogField, catalog: {hasFinishedFirstLoad}, queryStringEscaped, libraryQueryClause, assignableField, props: {visible}}} = this

        if (!hasFinishedFirstLoad) return

        // YFTS-7558 Avoid reloading assignable library items if contents cannot have changed
        const refreshDueToCatalogRefetch = !sectionValues && !_.includes(['Boolean', 'Enum', 'EnumList'], catalogField?.def?.type)
        if (refreshDueToCatalogRefetch) {
          // Don't track these observables unless we want to requery on their change
          const {es: {refetchId, lastRefetchType}} = catalog
        }

        runInAction(async () => {
          const {es: {refetchId, lastRefetchType}} = catalog
          if (visible && (!this.data || (store.loadingMore && store.virtualRowCount >= this.props.index) || !lastRefetchType || lastRefetchType == 'libraries' || lastRefetchType == library?.index || lastRefetchType == catalogField?.esIndex || lastRefetchType == library?.name)) {
            if (assignableField?.field) {
              const field = catalog._fieldByName[assignableField.field],
                sectionValues = catalog.sectionValuesFor(field?.section)

              if (sectionValues === null) {
                this.loading = true
                return
              }
            }

            await this.runVirtualRowQuery()
          }
        })
      }, {
        name: `Run catalog items virtual row data query for index ${this.props.index}`,
        delay: 5 // Delay here as when visible changes we don't want to immediately rerun queries for previously seen catalog libraries/assignable fields until other autorun in parent store has finished
      })
    ]

    return () => {
      toDispose.forEach(d => d())
    }
  }

  @action runVirtualRowQuery = async () => {
    const {error, props: {index}, store: {runQuery}, store, catalog} = this

    if (!error) {
      try {
        this.loading = true
        const data = await runQuery(index)
        runInAction(() => {
          this.data = data
          store.loadingMore = false
        })

        return data
      } catch (err) {
        this.error = err
        onSiteError(err)
      } finally {
        if (this.data != null) {
          this.loading = false
        }
      }
    }
  }
}

export const CatalogItemsDataVirtualRow = observer<{ index: number }>(
  function CatalogItemsDataVirtualRow({index}) {
    const store = useCatalogItemsListStore(),
      {
        sidebar, library, catalogItemsListData, prevPath, assignableField, props: {visible},
        catalog: {filter: {storeByLibraryId}}
      } = store,
      path = _.last(sidebar.path) as ICatalogItemDetailsPathElement,
      obsProps = useAsObservableSource({index}),
      localStore = useVipLocalStore((ws) => new CatalogItemsDataVirtualRowStore(ws, obsProps, store)),
      {loading, data, registerEffects, error} = localStore

    useEffect(registerEffects, [])

    //console.log({pageIndex, loading, data})

    useEffect(() => {
      if (!prevPath || (path?.where && prevPath !== path?.libraryId)) {
        store.prevPath = path?.libraryId
      }
    }, [path?.libraryId])

    const {dataMap, catalogField, sidebar: {searchText}} = store
    const libraryFilters = library?.name ? storeByLibraryId.get(library.name)?.filtersWithSelections : []
    return <Fragment>
      {loading && index === 0 && !data?.length ? visible ? <LoadingIndicator key='loader' className={css.loadingIndicator}/> : null
                                               : !loading && !store.loadingMore && !catalogItemsListData?.length && !data?.length && index === 0 &&
                                                 (error || (_.isEmpty(searchText) && _.isEmpty(libraryFilters))) && <EmptyDrawer
		                                             className={css.empty}
		                                             type={library?.label ?? catalogField?.label ?? 'items'}
		                                             message={error ? 'An error has occurred.' : undefined}
                                                                    // : _.isEmpty(searchText) && _.isEmpty(libraryFilters) ? undefined
                                                                    //                                                      : `No results found with\n ${libraryFilters?.length ? `applied filters${searchText ? ` and \n search text '${searchText}'` : ''}` : `search text '${searchText}'`}`}
	                                             />}

      {// Seems to interfere with infinite loader and cause slowdowns
        /*<FlipMove className={css.infiniteLoaderRowWrapper} enterAnimation='fade' appearAnimation='fade' leaveAnimation='accordionVertical' staggerDelayBy={10}>*/}
      {data?.map((r, i) => {
        const component = <CatalogDataItem key={i} data-virtual-row={index}
                                           data={r}
                                           style={_.isBoolean(assignableField?.showAsLibrary) ? undefined : toJS(assignableField?.showAsLibrary?.itemStyle)}/>
        if (!library) {
          return component
        }
        return (<CatalogDataItem_Mapped data={r} dataMap={dataMap} key={`${store.key}-${index}-${i}`}>
          {component}
        </CatalogDataItem_Mapped>)
      })}
      {/*</FlipMove>*/}
    </Fragment>
  })



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/CatalogItemsList/CatalogItemsDataVirtualRow.tsx